import { TalepKalem } from './talep-kalem';
import { Master } from './master';
import { Teklif } from './teklif';
import { TeklifFiyatDegisiklik } from './teklif-fiyat-degisiklik';

export class TeklifKalem {

  id: number;
  talepKalemId: number;
  teklifId: number;
  tutar: number;
  paraBirimiId: number;
  talepKalem: TalepKalem;
  paraBirimi: Master;
  checked = false;
  siparisMiktar: number;
  teklif: Teklif;
  teklifFiyatDegisiklikler: TeklifFiyatDegisiklik[];
  talepEdilen: number;
  stokKodu: string;
  stokAdi: string;
  olcuBirimi: string;


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.talepKalem != null) {
      this.talepKalem = new TalepKalem(obj.talepKalem);
    }
    if (obj.paraBirimi != null) {
      this.paraBirimi = new Master(obj.paraBirimi);
    }
    if (obj.teklif != null) {
      this.teklif = new Teklif(obj.teklif);
    }
    // if (obj.teklifFiyatDegisiklikler != null) {
    //   this.teklifFiyatDegisiklikler = new TeklifFiyatDegisiklik(obj.teklifFiyatDegisiklikler);
    // }
  }
}
